export default __webpack_public_path__ + "static/media/Novotel-Bangkok-Platinum.6e3233f6.jpg";